import { MainColor } from '../../palette/colors';

export const getFiltersTheme = () => {
  return {
    filters: {
      mainTextColor: 'navy95' as MainColor,
      border: 'coolGrey30' as MainColor,
      activeFilterIcon: 'navy10' as MainColor,
    },
    internalSelect: {
      backgroundColor: 'white95' as MainColor,
    },
  };
};

export type FiltersTheme = ReturnType<typeof getFiltersTheme>;
